module.exports = __webpack_public_path__ + "images/index/img05.f099950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuichi/img05.jpg
// module id = 6ag1
// module chunks = 21